const CHAT_ID_STORAGE_KEY = 'paired_chat_id';

export function getStoredChatId() {
  try {
    return localStorage.getItem(CHAT_ID_STORAGE_KEY);
  } catch (e) {
    return null;
  }
}

export function storeChatId(chatId) {
  try {
    localStorage.setItem(CHAT_ID_STORAGE_KEY, String(chatId));
  } catch (e) { /* ignore */ }
}

export function clearStoredChatId() {
  try {
    localStorage.removeItem(CHAT_ID_STORAGE_KEY);
  } catch (e) { /* ignore */ }
}
